import React from 'react'

import style from './HorizontalList.module.scss'

const HorizontalList = ({
  children,
  centered
}) => (
  <div className={style.list} data-centered={centered === ''}>
    {children}
  </div>
)

export default HorizontalList